import service from './storyDrawerService';
import controller from './StoryDrawerController';

const toLoad = [
  service,
  controller
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
